import styled from 'styled-components';

import { removeOutline } from './../../core';

export const NormalizedButton = styled.button`
  ${({ showOutline }) => !showOutline && removeOutline};
  background-color: transparent;
  border: none;
  border-color: transparent;
  box-sizing: border-box;
  margin: 0;

  & > div,
  & > span,
  & > svg,
  ::after,
  ::before {
    position: relative;
  }
`;
